document.addEventListener("DOMContentLoaded", function () {
  const parentButtons = document.querySelectorAll(".main-parent-link")

  parentButtons.forEach((button) => {
    button.setAttribute("aria-expanded", "false")
    button.addEventListener("click", function () {
      const wrapper = this.nextElementSibling
      const arrow = this.querySelector(".main-nav-arrow-icon")

      // Toggle current menu state
      const isExpanded = this.classList.toggle("active")
      this.setAttribute("aria-expanded", isExpanded)
      wrapper.classList.toggle("is-open")
      arrow?.classList.toggle("rotate")

      // Automatically open all grandchild links inside this wrapper
      wrapper.querySelectorAll(".grandchild-links").forEach((grandchild) => {
        grandchild.classList.add("is-open")
      })
    })
  })

  // Hamburger click
  const drawerToggle = document.getElementById("Navigation-drawer-button-header")
  const drawerContainer = document.getElementById("Navigation-drawer-header")

  if (drawerToggle && drawerContainer) {
    drawerToggle.setAttribute("aria-expanded", "false")
    drawerToggle.addEventListener("click", function () {
      const isOpen = drawerContainer.classList.contains("is-open")

      // Toggle drawer open class
      drawerContainer.classList.toggle("is-open")
      drawerToggle.setAttribute("aria-expanded", !isOpen)

      // Toggle icon visibility
      drawerToggle.classList.toggle("is-active", !isOpen)
      // Calculate height of announcement bar and header
      const announcementBar = document.querySelector(".section-announcement-bar")
      const header = document.querySelector(".section-header")

      // Calculate their total height
      const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0
      const headerHeight = header ? header.offsetHeight : 0
      const totalHeight = announcementHeight + headerHeight

      document.documentElement.style.setProperty("--header-total-height", totalHeight + "px")

      // Assign the total height to another div (create one for demo)
      const targetDiv = document.querySelector(".drawer__content")
      if (targetDiv) {
        targetDiv.style.top = totalHeight + "px"
      }
    })
  }

  /* Search Customization */
  function findRedirect(searchTerm) {
    const matches = window.searchRedirects.filter((redirect) => {
      if (redirect.matchType === "exact") {
        return searchTerm.toLowerCase() === redirect.searchTerm.toLowerCase()
      } else {
        return searchTerm.toLowerCase().includes(redirect.searchTerm.toLowerCase())
      }
    })
    return matches.sort((a, b) => (b.priority || 1) - (a.priority || 1))[0]
  }

  document.querySelectorAll('form[action="/search"]').forEach((form) => {
    form.addEventListener("submit", function (event) {
      const searchInput = form.querySelector('input[name="q"]')
      if (!searchInput) return

      const searchTerm = searchInput.value.trim()
      const redirect = findRedirect(searchTerm)

      if (redirect) {
        event.preventDefault()
        window.location.href = redirect.redirectUrl
      }
    })
  })

  if (window.location.pathname === "/search") {
    const params = new URLSearchParams(window.location.search)
    const query = params.get("q")
    if (query) {
      const redirect = findRedirect(query)
      if (redirect) {
        window.location.href = redirect.redirectUrl
      }
    }
  }

  /* Product Card Swatch Switcher & Image Preloader */
  const preloadedImages = new Set()

  function preloadImage(url) {
    if (!url || preloadedImages.has(url)) return
    preloadedImages.add(url)
    const img = new Image()
    img.src = url
  }

  function preloadCardSwatches(card) {
    if (!card || card.dataset.swatchesPreloaded === "true") return
    card.dataset.swatchesPreloaded = "true"
    card.querySelectorAll(".product-group-swatch-label").forEach((swatch) => {
      const img = swatch.getAttribute("data-product-image")
      const hover = swatch.getAttribute("data-product-hover-image")
      if (img) preloadImage(img)
      if (hover) preloadImage(hover)
    })
  }

  // Preload swatches on card hover / touch
  document.addEventListener(
    "pointerenter",
    function (event) {
      const card = event.target.closest(".product-card") || event.target.closest("product-card")
      if (card) preloadCardSwatches(card)
    },
    { passive: true, capture: true }
  )

  // Preload all visible cards via requestIdleCallback or setTimeout
  function preloadVisibleSwatches() {
    document.querySelectorAll(".product-card").forEach((card) => {
      preloadCardSwatches(card)
    })
  }

  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(preloadVisibleSwatches)
  } else {
    setTimeout(preloadVisibleSwatches, 1000)
  }

  // Click handler for instant swatch switching
  document.addEventListener("click", function (event) {
    const swatch = event.target.closest(".product-card .product-group-swatch-label")
    if (!swatch) return

    event.preventDefault()
    event.stopPropagation()

    const card = swatch.closest(".product-card") || swatch.closest("product-card")
    if (!card) return

    // Update active swatch
    card.querySelectorAll(".product-group-swatch-label").forEach((s) => s.classList.remove("active"))
    swatch.classList.add("active")

    const productUrl = swatch.getAttribute("data-product-url")
    const productTitle = swatch.getAttribute("data-product-title")
    const priceHtml = swatch.getAttribute("data-product-price-html")
    const badgesHtml = swatch.getAttribute("data-product-badges-html")
    const imgUrl = swatch.getAttribute("data-product-image")
    const imgSrcset = swatch.getAttribute("data-product-image-srcset")
    const hoverImgUrl = swatch.getAttribute("data-product-hover-image")
    const hoverImgSrcset = swatch.getAttribute("data-product-hover-image-srcset")
    const productHandle = swatch.getAttribute("data-product-handle")
    const isAvailableAttr = swatch.getAttribute("data-product-available")
    const isAvailable =
      isAvailableAttr === "true" ||
      (!swatch.classList.contains("unavailable") && isAvailableAttr !== "false")

    // Update title
    if (productTitle) {
      const titleSpan = card.querySelector(".product-card__title span")
      if (titleSpan) titleSpan.textContent = productTitle
      const titleLink = card.querySelector(".product-card__title a")
      if (titleLink) titleLink.setAttribute("title", productTitle)
    }

    // Update color label if present
    const swatchTitle = swatch.getAttribute("title")
    if (swatchTitle) {
      const colorValue = card.querySelector(".product-group-color-label__value")
      if (colorValue) colorValue.textContent = swatchTitle.toLowerCase()
    }

    // Update links
    if (productUrl) {
      card
        .querySelectorAll("a.product-card__link, .product-card__title a, a.quickshop__button")
        .forEach((link) => {
          link.setAttribute("href", productUrl)
        })
    }

    // Update price
    if (priceHtml) {
      const priceContainer = card.querySelector(".product-card__price")
      if (priceContainer) priceContainer.innerHTML = priceHtml
    }

    // Update primary image instantly
    if (imgUrl) {
      const primaryImg =
        card.querySelector(".product-card__media img:not(.hover-img)") ||
        card.querySelector(".product-card__media img")
      if (primaryImg) {
        primaryImg.loading = "eager"
        primaryImg.fetchPriority = "high"
        primaryImg.src = imgUrl
        if (imgSrcset) primaryImg.srcset = imgSrcset
        if (productTitle) primaryImg.alt = productTitle
      }
    }

    // Update hover image
    const hoverImg = card.querySelector(".product-card__media img.hover-img")
    if (hoverImg) {
      if (hoverImgUrl) {
        hoverImg.loading = "eager"
        hoverImg.src = hoverImgUrl
        if (hoverImgSrcset) hoverImg.srcset = hoverImgSrcset
        if (productTitle) hoverImg.alt = productTitle
        hoverImg.style.display = ""
      } else {
        hoverImg.style.display = "none"
      }
    }

    // Update card handle & reset size load state if quickshop is used
    if (productHandle) {
      card.setAttribute("data-product-handle", productHandle)
      card.dataset.sizeLoaded = "false"
      const sizeOptions = card.querySelector(".size-options")
      if (sizeOptions) {
        sizeOptions.innerHTML = ""
        sizeOptions.style.display = "none"
      }
    }

    // Update card sold out state
    card.classList.toggle("product-card__sold-out", !isAvailable)

    // Update badges (Sold Out / Sale / Pre-order etc.)
    const currentBadgeWrapper = card.querySelector(".product-card__badges")
    if (badgesHtml !== null && badgesHtml !== undefined) {
      const trimmedBadges = badgesHtml.trim()
      if (trimmedBadges !== "") {
        if (currentBadgeWrapper) {
          currentBadgeWrapper.outerHTML = trimmedBadges
        } else {
          const info = card.querySelector(".product-card__info")
          if (info) {
            info.insertAdjacentHTML("afterbegin", trimmedBadges)
          }
        }
      } else if (currentBadgeWrapper) {
        currentBadgeWrapper.remove()
      }
    } else {
      // Fallback if data-product-badges-html attribute is missing
      if (isAvailable) {
        if (currentBadgeWrapper) {
          const soldBadge = currentBadgeWrapper.querySelector(
            ".product-card__badge--rounded--sold-out, .product-card__badge--square--sold-out, [class*='sold-out'], [class*='sold_out'], [class*='sold out']"
          )
          if (soldBadge) soldBadge.remove()
          if (!currentBadgeWrapper.children.length) currentBadgeWrapper.remove()
        }
      } else {
        if (currentBadgeWrapper) {
          const soldBadge = currentBadgeWrapper.querySelector(
            ".product-card__badge--rounded--sold-out, .product-card__badge--square--sold-out, [class*='sold-out'], [class*='sold_out'], [class*='sold out']"
          )
          if (!soldBadge) {
            const newSold = document.createElement("span")
            newSold.className = "product-card__badge product-card__badge--rounded--sold-out"
            newSold.textContent = "Sold out"
            currentBadgeWrapper.appendChild(newSold)
          }
        } else {
          const info = card.querySelector(".product-card__info")
          if (info) {
            info.insertAdjacentHTML(
              "afterbegin",
              '<span class="product-card__badges"><span class="product-card__badge product-card__badge--rounded--sold-out">Sold out</span></span>'
            )
          }
        }
      }
    }

    // Update CTA button and Notify Me link
    const notifyMeLinks = card.querySelectorAll("a.quickshop__button")
    const addToCartButton = card.querySelector(".product-card__add-to-cart--button")

    if (isAvailable) {
      // Product is in stock
      notifyMeLinks.forEach((link) => {
        link.style.setProperty("display", "none", "important")
      })
      if (addToCartButton) {
        addToCartButton.classList.remove("js-hidden", "large-up-hide")
        addToCartButton.removeAttribute("disabled")
        addToCartButton.disabled = false
        addToCartButton.style.removeProperty("display")
        addToCartButton.style.display = ""
        if (productHandle) {
          addToCartButton.setAttribute("data-product-url", "/products/" + productHandle)
        }
        if (productUrl) {
          if (addToCartButton.hasAttribute("onclick")) {
            addToCartButton.setAttribute("onclick", `window.location.href='${productUrl}'`)
          }
          const parentLink = addToCartButton.closest("a")
          if (parentLink) {
            parentLink.setAttribute("href", productUrl)
            if (productTitle) parentLink.setAttribute("aria-label", productTitle)
          }
        }
      }
    } else {
      // Product is out of stock (sold out)
      notifyMeLinks.forEach((link) => {
        link.style.removeProperty("display")
        link.style.display = ""
        if (productUrl) link.setAttribute("href", productUrl)
      })
      if (addToCartButton) {
        addToCartButton.classList.add("js-hidden", "large-up-hide")
        addToCartButton.setAttribute("disabled", "disabled")
        addToCartButton.disabled = true
        addToCartButton.style.setProperty("display", "none", "important")
      }
    }
  })
})
